// Keep the offer CTA usable when its section is hidden or removed.
document.addEventListener('click', (event) => {
 const link = event.target.closest('a[data-offer-link]');
 if (!link || link.getAttribute('href') !== '#offer' || document.getElementById('offer')) return;
 if (link.dataset.productUrl) { event.preventDefault(); window.location.assign(link.dataset.productUrl); }
});
// Show a selected question immediately in Shopify's theme editor.
document.addEventListener('shopify:block:select', (event) => {
 const details = event.target.closest('details');
 if (details) details.open = true;
});
